export const ERROR_MICROFORM =
  'There was an error loading the data for the payment. Close the tab and try again.';
export const ERROR_TIMEOUT_MICROFORM =
  'The payment link has expired. Please close this tab, hit the back button on the previous screen and try again.';
export const ERROR_TOKEN = 'Verify Card details and try again';

// As per https://developer.cybersource.com/docs/cybs/en-us/digital-accept-flex/developer/all/rest/digital-accept-flex/microform-integ-v2/api-reference-v2/class-microform-error-v2.html
export const TOKEN_CREATION_TIMEOUT_REASONS = [
  'CREATE_TOKEN_UNABLE_TO_START',
  'CREATE_TOKEN_VALIDATION_SERVERSIDE',
  'CREATE_TOKEN_TIMEOUT',
];

export default {
  ERROR_MICROFORM,
  ERROR_TIMEOUT_MICROFORM,
  ERROR_TOKEN,
  TOKEN_CREATION_TIMEOUT_REASONS,
};
